import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";
import { cn } from "@/lib/utils";

export const Cursor = () => {
  const [enabled] = useState(() => window.matchMedia("(pointer: fine)").matches);
  const [hover, setHover] = useState(false);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const rx = useSpring(x, { stiffness: 350, damping: 32, mass: 0.6 });
  const ry = useSpring(y, { stiffness: 350, damping: 32, mass: 0.6 });

  useEffect(() => {
    if (!enabled) return;
    document.documentElement.classList.add("has-cursor");
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
      setHover(!!e.target.closest?.("a, button, [role=combobox], [role=tab]"));
    };
    window.addEventListener("pointermove", move, { passive: true });
    return () => {
      document.documentElement.classList.remove("has-cursor");
      window.removeEventListener("pointermove", move);
    };
  }, [enabled, x, y]);

  if (!enabled) return null;
  return (
    <>
      <motion.div style={{ x, y }} className="pointer-events-none fixed left-0 top-0 z-[300] -ml-[3px] -mt-[3px] h-1.5 w-1.5 rounded-full bg-white" aria-hidden data-testid="cursor-dot" />
      <motion.div style={{ x: rx, y: ry }} className={cn("pointer-events-none fixed left-0 top-0 z-[299] -ml-4 -mt-4 h-8 w-8 rounded-full border transition-colors duration-300", hover ? "border-volt" : "border-white/40")} aria-hidden data-testid="cursor-ring" />
    </>
  );
};

export const ScrollProgress = ({ progress }) => (
  <motion.div style={{ scaleX: progress }} className="fixed inset-x-0 top-0 z-[90] h-[2px] origin-left bg-gradient-to-r from-volt via-volt to-signal" data-testid="scroll-progress" />
);
